import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { getConfirmation, AuthorizationSchemeService, AuthorizationScheme } from '@mango/core';

@Component({
    selector: 'cij-itemtile',
    templateUrl: './itemtile.component.html',
    styleUrls: ['./itemtile.component.css']
})
export class ItemTileComponent implements OnInit {

    @Input() title: string;
    @Input() item: any;
    @Input() dtoType: string;

    authScheme: AuthorizationScheme;

    constructor(public dialog: MatDialog, private authSchemeService: AuthorizationSchemeService) { }

    @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();

    ngOnInit(): void {
        this.authScheme = this.authSchemeService.getMyScheme();
    }

    async delete() {
        let ok = await getConfirmation(this.dialog, "Verwijderen", "Weet u zeker dat u dit item wilt verwijderen?");

        if (ok) {
            this.onDelete.emit(this.item);
        }
    }

    canDelete(): boolean {
        return this.authScheme.canDelete(this.dtoType);
    }
}
